"use client";

import { type MotionProps, motion } from "framer-motion";
import { DynamicIcon } from "lucide-react/dynamic";
import React from "react";
import { TypographyH3, TypographySmall } from "@/components/ui/typography";
import { cls } from "@/lib/utils";
import type { IconName } from "./consts";

interface KeyElementsItemProperties extends MotionProps {
  title: string;
  content: string;
  icon: IconName;
}

function KeyElementsItem({
  title,
  content,
  icon,
  ...properties
}: KeyElementsItemProperties) {
  return (
    <motion.div
      key={title}
      className={cls`flex flex-1 flex-col md:flex-row gap-2`}
      {...properties}
    >
      <div className={cls`flex flex-col justify-center items-center px-10`}>
        <DynamicIcon name={icon} size={50} />
      </div>

      <div className={cls`flex flex-col gap-2`}>
        <TypographyH3>{title}</TypographyH3>
        <TypographySmall className={cls`mt-0!`}>{content}</TypographySmall>
      </div>
    </motion.div>
  );
}

export default KeyElementsItem;
